import {
  SYSTableDefIds,
  html,
  ovl,
} from "../../../../../../../../../_ovlclient/src"
import { Data } from "../../../../../../../../../_ovlclient/src/dataapi"
import { FileGet } from "../../../../../../../../../_ovlclient/src/global/globalapi"
import {
  DialogClose,
  DialogOkCancel,
} from "../../../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import { DialogGet } from "../../../../../../../../../_ovlclient/src/library/dialog/helpers"
import { SYSDialogBase } from "../../../../../../../../../_ovlclient/src/library/dialog/sysdialog2base"
import { SYSBaseDialog } from "../../../../../../../../../_ovlclient/src/library/dialog/sysdialogbase"
import { DialogGetParts } from "../../../../../../../../../_ovlclient/src/library/dialog/sysdialogholder"
import {
  FieldSetFocus,
  FieldSetVal,
  FieldVal,
} from "../../../../../../../../../_ovlclient/src/library/forms/fieldapi"
import {
  FormGet,
  FormIsValid,
  FormRemove,
} from "../../../../../../../../../_ovlclient/src/library/forms/formapi"
import {
  ProcessEnd,
  ProcessIsRunning,
  ProcessStart,
} from "../../../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import { ScreenCurrent } from "../../../../../../../../../_ovlclient/src/library/screenapi"
import { _GetOvlSysColDefault } from "../../../../../../../../../_ovlclient/src/library/table/actions"
import { OvlSysColumn } from "../../../../../../../../../_ovlclient/src/library/table/table"
import { TableGet } from "../../../../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../../../../_ovlclient/src/textapi"
import { OfferingMainRefresh } from "../../../../../screens/qutoffering/offering/helpers"

export class CompDialogQUTOfferingPos extends SYSDialogBase {
  async getUI() {
    let tb = TableGet("QUTOfferingPos")
    let rowsCount = tb.def.uiState.rowsCount
    let commissionValid = FormIsValid(
      FormGet("SYSEdit", { instance: "QUTOfferingPos" }).formState
    )

    let currentEditsCount = Object.keys(tb.rows).filter(
      (f) => (tb.rows[f].OvlSysState as OvlSysColumn).editRow.selected
    ).length

    let isNew = ScreenCurrent() !== "QUTOfferingDetails"
    let cntct
    if (ScreenCurrent() === "QUTOfferingAdminCut") {
      cntct = html`<ovl-listcontrol
        .props=${() =>
          FormGet("SYSEdit", { instance: "QUTOfferingPos" }).fields[
            "CntctCode"
          ]}
      ></ovl-listcontrol>`
    }

    let dialogParts: DialogGetParts = {
      dismissedCallbackFn: () => {
        return
      },
      title: () =>
        html`<div class="ovl-flex">
          <div>Zuschnitt: Positionen</div>
          &nbsp;&nbsp;
          <a
            href="#"
            class="fd-link"
            tabindex="0"
            @click=${(e) => {
              e.preventDefault()
              FileGet({
                cat: "OfferingToolDocPDF",
                id1: "CUT",
              })
            }}
          >
            <span class="sap-icon--pdf-attachment sap-icon--xl"></span>
            ${T("QUTOfferingOfferingManual")}
          </a>
        </div>`,
      body: () =>
        html`<ovl-textbox
            .props=${() =>
              FormGet("SYSEdit", { instance: "QUTOfferingPos" }).fields[
                "SYSEdit_Commission"
              ]}
          ></ovl-textbox>
          ${cntct}
          <ovl-table
            class="fd-table"
            .props=${() => <SYSTableDefIds>"QUTOfferingPos"}
          >
          </ovl-table> `,
      tableDefButtonsInFooter: "QUTOfferingPos",
      footer: () => {
        let startOfferDisabled =
          ProcessIsRunning("GENRefreshData") ||
          !commissionValid ||
          rowsCount < 1 ||
          currentEditsCount > 0
        let createOrApplyButton
        if (isNew) {
          createOrApplyButton = html`
            <button
              ?disabled=${startOfferDisabled}
              @click=${async () => {
                try {
                  ProcessStart("GENRefreshData")
                  let positions0 = JSON.parse(JSON.stringify(tb.rows))
                  // convert posid to string to match the backend initcutoffer endpoint type
                  let positions = []
                  Object.keys(positions0).forEach((k) => {
                    positions0[k].U_PosId = positions0[k].U_PosId.toString()
                    positions.push(positions0[k])
                  })
                  let commission = FieldVal(
                    FormGet("SYSEdit", {
                      instance: "QUTOfferingPos",
                    }).fields["SYSEdit_Commission"]
                  )
                  let cntctCode
                  let cardCode
                  if (ScreenCurrent() === "QUTOfferingAdminCut") {
                    cntctCode = FieldVal(
                      FormGet("SYSEdit", {
                        instance: "QUTOfferingPos",
                      }).fields["CntctCode"]
                    )
                    cardCode = FieldVal(
                      FormGet("QUTBPFilter").fields["CardCode"]
                    )
                  }
                  var res = await Data("offeringpos/initcutoffer", {
                    positions,
                    commission,
                    cntctCode,
                    cardCode,
                    fileName: this.state.app.features.QUTOffering.cutFileName,
                  })
                  let docEntry = res.data

                  if (docEntry) {
                    await OfferingMainRefresh(
                      ovl.getState(),

                      docEntry,
                      ScreenCurrent()
                    )

                    Data("offering/recalc", { docEntry })
                    DialogClose("QUTOfferingPos")
                  }
                } finally {
                  ProcessEnd("GENRefreshData")
                }
              }}
              id="start_offer"
              class="fd-button"
            >
              <span class="fd-button__text"
                >${T("QUTOfferingPosStartOffer")}</span
              >
              <i class="sap-icon--activate"></i>
            </button>
          `
        } else {
          // we are in "Apply Mode"
          createOrApplyButton = html`
            <button
              ?disabled=${startOfferDisabled ||
              !this.state.app.features.QUTOffering.cutListDirty}
              @click=${async () => {
                if (tb.staticFilterGet()["U_DocEntry"] === -1) {
                  ProcessStart("GENRefreshData")
                  try {
                    let docEntry =
                      TableGet("QUTOffering").rows[
                        this.state.app.features.QUTOffering.selectedOfferKey
                      ]["DocEntry"]

                    // it was a excel loaded freshly
                    // we need to bulk update the pos on the server
                    let positions0 = JSON.parse(JSON.stringify(tb.rows))
                    // convert posid to string to match the backend initcutoffer endpoint type
                    let positions = []
                    Object.keys(positions0).forEach((k) => {
                      positions0[k].U_PosId = positions0[k].U_PosId.toString()

                      positions0[k].U_DocEntry = docEntry
                      positions.push(positions0[k])
                    })
                    let commission = FieldVal(
                      FormGet("SYSEdit", {
                        instance: "QUTOfferingPos",
                      }).fields["SYSEdit_Commission"]
                    )
                    let cntctCode
                    let cardCode
                    if (ScreenCurrent() === "QUTOfferingAdminCut") {
                      cntctCode = FieldVal(
                        FormGet("SYSEdit", {
                          instance: "QUTOfferingPos",
                        }).fields["CntctCode"]
                      )
                      cardCode = FieldVal(
                        FormGet("QUTBPFilter").fields["CardCode"]
                      )
                    }
                    await Data("offeringpos/initcutoffer", {
                      positions,
                      commission,
                      cntctCode,
                      cardCode,
                      fileName: this.state.app.features.QUTOffering.cutFileName,
                      docEntry,
                    })
                  } finally {
                    ProcessEnd("GENRefreshData")
                  }
                }

                this.state.app.features.QUTOffering.detailsChanged =
                  this.state.app.features.QUTOffering.selectedOfferKey
                this.state.app.features.QUTOffering.cutPositionsChanged = true
                TableGet("QUTOfferingMaterial").init({
                  resetStrategy: { ClearData: true },
                })
                DialogClose("QUTOfferingPos")
              }}
              id="start_offer"
              class="fd-button"
            >
              <span class="fd-button__text"
                >${T("QUTOfferingPosApplyPos")}</span
              >
              <i class="sap-icon--accept"></i>
            </button>
          `
        }

        return html`
          <button
            ?disabled=${ProcessIsRunning("GENRefreshData")}
            @click=${async () => {
              FileGet({
                cat: "OfferingPosCutTemplate",
              })
            }}
            id="dl_template"
            class="fd-button"
          >
            <span class="fd-button__text"
              >${T("QUTOfferingPosDownloadTemplate")}</span
            >
            <i class="sap-icon--download"></i>
          </button>

          &nbsp; &nbsp;
          <button
            ?disabled=${ProcessIsRunning("GENRefreshData")}
            @click=${async () => {
              if (
                TableGet("QUTOfferingPos").def.uiState.rowsCount > 0 &&
                (await DialogOkCancel(T("QUTOfferingPosLoadFromExcel"))) === 2
              ) {
                return
              }
              let browseFileEl = <HTMLInputElement>(
                document.getElementById("offering-newfile")
              )
              let acceptExtensions = ".xlsx"
              browseFileEl.setAttribute("accept", acceptExtensions)
              browseFileEl.value = ""
              browseFileEl.click()
            }}
            id="asset_browse_button1"
            class="fd-button"
            aria-label="file auswählen"
          >
            <span class="fd-button__text">${T("QUTOfferingPosUpload")}</span>
            <i class="sap-icon--upload"></i>
          </button>

          <div
            class="fd-file-uploader__hidden"
            aria-live="polite"
            aria-atomic="true"
          ></div>
          <input
            id="offering-newfile"
            class="fd-file-uploader__hidden"
            @input=${async (e) => {
              ProcessStart("GENRefreshData")
              try {
                var formData = new FormData()
                formData.append("File", e.target.files[0])
                formData.append("uploadDefId", "cut")
                let res = await Data("offeringpos/uploadpos", formData, {
                  isFormData: true,
                })
                FieldSetVal(
                  FormGet("SYSEdit", { instance: "QUTOfferingPos" }).fields[
                    "SYSEdit_Commission"
                  ],
                  res.data.commission
                )
                this.state.app.features.QUTOffering.cutFileName =
                  res.data.fileName
                await tb.refresh({
                  localData: res.data.res.map((r) => {
                    r.U_DocEntry = -1
                    return r
                  }),
                  forcedFilters: { staticFilter: { U_DocEntry: -1 } },
                  resetStrategy: { ClearData: true },
                })
                let allFormStates = await Promise.all(
                  tb.getKeys().map((k) => {
                    return tb.formStateInitForRowKey(k)
                  })
                )

                await Promise.all(
                  allFormStates.map(async (formState) => {
                    if (!FormIsValid(formState)) {
                      return tb.formEditRow(formState.tableRowKey, {
                        forceInline: true,
                      })
                    } else {
                      // we are not interested in the formstate so just remove it
                      tb.formRemoveRowFormState(formState.tableRowKey)
                    }
                  })
                )
                this.state.app.features.QUTOffering.cutListDirty = true
              } finally {
                ProcessEnd("GENRefreshData")
              }
            }}
            }
            type="file"
          />
          &nbsp; &nbsp; ${createOrApplyButton} &nbsp; &nbsp;
          <button
            ?disabled=${ProcessIsRunning("GENRefreshData")}
            @click=${async (e) => {
              if (
                !this.state.app.features.QUTOffering.cutListDirty ||
                (await DialogOkCancel(
                  T("QUTOfferingPosCloseDialogConfirm")
                )) === 1
              ) {
                DialogClose(this.dialog)
              }
            }}
            id="ovl_row_save_cancel${this.id}"
            title="${T("SYSCancel")}"
            class="fd-button fd-button--negative"
          >
            <i class="sap-icon--decline"></i>
          </button>
        `
      },
    }
    return await DialogGet(this, dialogParts)
  }
  async firstUpdated() {
    FieldSetFocus(
      FormGet("SYSEdit", {
        instance: "QUTOfferingPos",
      }).fields["SYSEdit_Commission"]
    )
  }
}
